/* RESPONSIBLE TEAM: team-ai-agent */
type MemoryField = { identifier: string };

export type MemoryFieldColumn = {
  key: string;
  label: string;
  identifier: string;
  isCompany: boolean;
};

type OutcomeWithMemoryFields = {
  required_memory_fields: MemoryField[];
  optional_memory_fields: MemoryField[];
};

export function toUserAttributeKey(identifier: string): string {
  return identifier.replace(/^company\./, 'qualificationCompany.');
}

export function toDisplayLabel(identifier: string): string {
  return identifier
    .replace('custom_data.', '')
    .replace('fin_sdr_', '')
    .replace(/[_.]/g, ' ')
    .replace(/^\w/, (c: string) => c.toUpperCase());
}

export function getOutcomeMemoryFields(outcome: OutcomeWithMemoryFields): MemoryFieldColumn[] {
  let allFields = [
    ...(outcome.required_memory_fields || []),
    ...(outcome.optional_memory_fields || []),
  ];
  return allFields.map((field) => {
    let isCompany = field.identifier.startsWith('company.');
    return {
      key: toUserAttributeKey(field.identifier),
      label: toDisplayLabel(field.identifier),
      identifier: field.identifier,
      isCompany,
    };
  });
}
